import { Box, type BoxProps } from "@mui/material";
import React, { useState } from "react";

import { type AllocationFragment } from "src/graphql/generated/types";
import { isActivationKey } from "src/utils/activationKey";

import { ExpandIcon } from "../../ExpandIcon";
import { ExpenseType } from "../ExpenseType";
import { ExpenseTypesWrapper } from "../ExpenseTypesWrapper";
import { FirstLevelRow } from "../FirstLevelRow";

type Props = {
  allocation: AllocationFragment;
} & BoxProps;

export const Allocation = ({ allocation, ...boxProps }: Props) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  return (
    <Box {...boxProps}>
      <FirstLevelRow
        key={allocation.id}
        role="button"
        ariaLabel={allocation.name.toLowerCase()}
        onClick={() => {
          setIsExpanded(!isExpanded);
        }}
        toAllocate={allocation.toAllocate}
        vat={allocation.vat}
        recoverable={allocation.recoverable}
        tabIndex={0}
        onKeyDown={(e) => {
          if (isActivationKey(e)) {
            setIsExpanded(!isExpanded);
          }
        }}
        aria-expanded={isExpanded}
      >
        <ExpandIcon sx={{ mr: 2 }} />
        <div>
          {allocation.code} - {allocation.name}
        </div>
      </FirstLevelRow>
      {isExpanded && (
        <ExpenseTypesWrapper>
          {allocation.expenseTypes.map((expenseType) => {
            return <ExpenseType key={expenseType.id} data={expenseType} sx={{ mt: 2 }} />;
          })}
        </ExpenseTypesWrapper>
      )}
    </Box>
  );
};
